/*
@file    index.jsx
@class   UserNotification

@author Carlos Sepúlveda. <csepulveda@atentus.com>
(c) Servicios de Monitoreo S.A. - Santiago, Chile

@brief  Componente destinado a las notifiaciones de usuario en el reporte
@date   Feb/2021

*/

import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

import { withRouter } from 'react-router-dom';
// Material helpers
import { withStyles } from '@material-ui/core/styles';
// Material components
import IconButton from '@material-ui/core/IconButton';
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import Grid from '@material-ui/core/Grid';
import ClearIcon from '@material-ui/icons/Clear';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
// Component styles
import styles from './styles';
// local method
import { getUserNotifications } from "../../../../services/getUserNotifications";
import { createNotificationControl } from "../../../../services/createNotificationControl";
import { reportFetchError } from '../../../../observability/rum';

import moment from 'moment'
import 'moment/locale/es'
import Backdrop from "@material-ui/core/Backdrop";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
moment.locale('es')

/*
@class UserNotification
@brief Componente notificaciones de reporte.
*/
class UserNotification extends Component {

    constructor(props) {
        super(props);
        this.handleOnclickPrevNotif = this.handleOnclickPrevNotif.bind(this);
        this.handleOnclickNextNotif = this.handleOnclickNextNotif.bind(this);
        this.handleChange = this.handleChange.bind(this)
        this.handleClose = this.handleClose.bind(this)

        this.state = {
            notifications: [],// notificaciones del usuario.
            notificationsId: [], // notificaciones id del usuario
            posNotific: 0,// posicion de notificaciones en el arreglo.
            checked: false,// check de para no mostrar mas las notifiaciones.
            statusControl: null,// status de la peticion, 'no mostrar mas notificaciones.'
            title: '',// titulo notificacion
            typeNoti: '',// tipo de notificacion
            numberOfNotific: 0, // cantidad de notificaciones
            openModalNot: true

        };
    }
    /*
    @brief Método que permite ejecutar limpieza de intervalo, se ejecuta al desmontar el componente.
    */
    componentWillUnmount() {
        clearInterval(this.timerID);
    }
    /*
    @brief Método que permite  obtener las notificaciones del usuario
    */
    componentDidMount() {
        let token = sessionStorage.getItem('key')
        let idUser = sessionStorage.getItem('user')
        //let idUser = 7255
        let _notifications = []
        let _notificationsId = []
        // método que obtiene las notificaciones de usuario.
        getUserNotifications(token, idUser).then(data => {
            Object.keys(data).map((index, val) => {
                // Organiza datos de notificacion para su iteración
                _notifications.push(data[index])
                // obtiene los id de las notificaciones obtenidas
                _notificationsId.push(data[index]["notificacion_id"])
            })
            // si no tiene notificaciones que mostrar cierra dialogo
            if (_notificationsId.length == 0) {
                this.handleClose()
                return
            }
            // setea los estados de notificacion y ids notificacion
            this.setState({
                notifications: _notifications,
                notificationsId: _notificationsId,
                title: _notifications[0]["notificacion_titulo"],
                typeNoti: _notifications[0]["notificacion_tipo"]
            })
        })
        .catch((error) => {
            reportFetchError('UserNotification', error)
            this.handleClose()
        })
    }
    /*
    @brief Método que permite cambiar a la notificacion anterior del  notificacion modal.
    */
    handleOnclickPrevNotif = () => {
        // indice de la notificacion siguiente
        const prevNot = this.state.posNotific - 1
        // si no existen notificaciones no setea estado.
        if (this.state.posNotific == 0) {
            return
        }
        // estado para retroceder una notificacion
        this.setState({
            posNotific: prevNot,
            title: this.state.notifications[prevNot]["notificacion_titulo"],
            typeNoti: this.state.notifications[prevNot]["notificacion_tipo"]
        })
    }
    /*
    @brief Método que permite cambiar a la notificacion siguiente del  notificacion modal.
    */
    handleOnclickNextNotif = () => {
        // indice de la notificacion siguiente
        const nextNot = this.state.posNotific + 1
        // no realiza nada cuando tiene al menos una notificacion o ya esta en la ultima notificacion.
        if (this.state.notificationsId.length <= 1 || this.state.notificationsId.length == nextNot) {
            return
        }
        this.setState({
            posNotific: nextNot,
            title: this.state.notifications[nextNot]["notificacion_titulo"],
            typeNoti: this.state.notifications[nextNot]["notificacion_tipo"]
        })
    }
    /*
    @brief Cambia el estado del checkbox
    */
    handleChange = () => {
        this.setState(prevState => ({
            checked: !prevState.checked
        }))
    }
    /*
    @brief envia petición a la api para desactivar una notificación.
    @param notificationId  .
    */
    dispatchSetShowNot = (notificationId) => {
        let token = sessionStorage.getItem('key')
        let idUser = sessionStorage.getItem('user')

        if (this.state.checked) {
            createNotificationControl(this.state.notificationsId, idUser, token).then(data => {
                this.handleClose()
            })
            .catch((error) => {
                reportFetchError('UserNotification', error)
                this.handleClose()
            })
        }
        else {
            this.handleClose()
        }
    }
    /*
    @brief cerrar modal.
    @param notificationId  .
    */
    handleClose = event => {
        this.setState({
            openModalNot: false
        })
    };

    render() {

        const { classes, handleClose, t } = this.props;
        const { notifications, posNotific, checked, title, typeNoti, openModalNot } = this.state;
        const quantitynot = notifications.length
        // estilos de clases
        let classBackBut = {}
        let classNextBut = {}
        let htmlContent = null

        if (quantitynot === 0 || posNotific == 0) {
            classBackBut = { color: '#12161B', cursor: 'default' }
        } else {
            classBackBut = { color: '#f57000', cursor: 'pointer' }
        }
        // solo cuando existan mas notificaciones que mostrar despúes de la última.
        if (quantitynot > 1 && posNotific + 1 < quantitynot) {
            classNextBut = { color: '#f57000', cursor: 'pointer' }
        } else {
            classNextBut = { color: '#12161B', cursor: 'default' }
        }

        // agrega el cuerpo html solo si encuentra notificaciones activas para el usuario.
        if (notifications.length > 0) {
            htmlContent = notifications[posNotific]["notificacion_cuerpo"]
            return (
                <Dialog
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={openModalNot}
                    onClose={this.handleClose}
                    closeAfterTransition
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                    maxWidth={'md'}
                    fullWidth={true}
                >
                    <DialogTitle className='at-blue-background'>
                        <Typography variant='h5'>
                            {t('notifications.title', { type: typeNoti })}
                        </Typography>
                        <IconButton style={{ position: 'absolute', right: 1, top: 1 }} onClick={this.handleClose}>
                            <ClearIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent className={classes.content}>
                        <Box>
                            {title}
                        </Box>
                        <Box style={{ marginTop: 20, marginBottom: 30 }}>
                            <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
                        </Box>
                        <Grid
                            container
                        >
                            <Grid
                                item
                                alignContent={'center'}
                                xs={6}
                            >
                                <SkipPreviousIcon titleAccess={t('notifications.prev_tooltip')} style={classBackBut} onClick={this.handleOnclickPrevNotif} />
                            </Grid>
                            <Grid
                                item
                                xs={6}
                            >
                                <SkipNextIcon fontSize="large" titleAccess={t('notifications.next_tooltip')} style={classNextBut} onClick={this.handleOnclickNextNotif} />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className={classes.portletFooter} align="right">
                        <Box style={{ marginRight: 50 }}>
                            <Checkbox
                                checked={checked}
                                onChange={this.handleChange}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                            />
                            <Typography variant="span" color={'initial'}>{t('notifications.no_more')}</Typography>
                        </Box>
                        <Button variant="contained" onClick={this.dispatchSetShowNot} color='primary' size='small'>{t('notifications.accept')}</Button>
                    </DialogActions>
                </Dialog>

            )
        }
        return null


    }
}
export default compose(withRouter, withStyles(styles))(withTranslation()(UserNotification));